<script></script>

<div class="main">
    <div class="title">
        COMMUNICATE
    </div>
    <div class="img-wrapper">
        <img width="100%" height="100%" src="images/web3_pages/communicate.png" alt="communicate">
    </div>
    <div class="detail">
        Publishing narrative and success stories around the utility of FNFTs.
    </div>
</div>

<style>
    .main{
        width: 33.854vw;
        height: 47.917vw;
        background-color: #FF007F;
        box-shadow: -0.208vw 0.208vw 0.417vw rgba(0, 0, 0, 0.5);
        border-radius: 2.083vw;
        position: relative;
        font-family: 'Montserrat';
        font-style: normal;
        color: #ffffff;
    }
    .title{
        font-weight: 900;
        font-size: 2.604vw;
        line-height: 74.5%;
        text-align: center;
        position: absolute;
        top: 3.37vw;;
        width: 100%;
    }
    .img-wrapper{
        position: absolute;
        top: 10.714vw;
        left: 5.729vw;
        width: 22.396vw;
        height: 22.396vw;
    }
    .img-wrapper img{
        pointer-events: none;
    }
    .detail{
        width: 21.042vw;
        position: absolute;
        top: 38.683vw;
        left: 0;
        right: 0;
        margin: auto;
        font-weight: 600;
        font-size: 1.563vw;
        line-height: 100%;
    }
</style>